// extracted by mini-css-extract-plugin
export default {"image":"dSF_1i"};